export default "__VITE_ASSET__4ZRU7O_N__"